"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const has_1 = __importDefault(require("lodash/has"));
const formik_1 = require("formik");
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const fa_1 = require("react-icons/fa");
const TableRowContext_1 = require("@/components/DynamicTable/TableRowContext");
const DyanmicTableHead_1 = __importDefault(require("@/components/DynamicTable/DyanmicTableHead"));
const DynamicTableRow_1 = __importDefault(require("@/components/DynamicTable/DynamicTableRow"));
const SimpleCell_1 = __importDefault(require("@/components/DynamicTable/Cells/SimpleCell"));
const AutocompleteField_1 = __importDefault(require("@/components/AutocompleteField"));
const DeletableCell_1 = __importDefault(require("@/components/DynamicTable/Cells/DeletableCell"));
const ProductsToast_1 = __importDefault(require("@/pages/Products/components/ProductsToast"));
const ProductPrompt_1 = __importDefault(require("../ProductPrompt"));
const RemoveAssociationDialog_1 = __importDefault(require("../RemoveAssociationDialog"));
const constants_1 = require("./constants");
const style_1 = require("./style");
function AssociationTable({ componentRowInputs, errors, selectComponentOptions, onTogglePrompt, isSavePromptVisible, onDelete, }) {
    const onChange = react_1.default.useCallback((arrayHelpers, index) => (event, value, reason) => {
        if (!isSavePromptVisible && onTogglePrompt) {
            onTogglePrompt();
        }
        if (reason === "clear") {
            arrayHelpers.form.setFieldValue(`associatedComponents[${index}]`, null);
            return;
        }
        const newValue = {
            name: value?.label,
            id: value?.value,
            unit: value?.unit,
            order: value?.order,
        };
        arrayHelpers.form.setFieldValue(`associatedComponents[${index}]`, newValue);
        if (index ===
            arrayHelpers.form.values["associatedComponents"].length - 1)
            arrayHelpers.push({
                name: "Select Component",
                id: "-",
                unit: "-",
                order: 0,
            });
    }, []);
    const onDeleteComponent = react_1.default.useCallback((arrayHelpers, componentToBeUnlinked, index) => () => {
        if (onDelete) {
            onDelete(componentToBeUnlinked, index);
        }
        else {
            arrayHelpers.remove(index);
        }
    }, [onDelete]);
    return (react_1.default.createElement(formik_1.Form, null,
        react_1.default.createElement(formik_1.FieldArray, { name: "associatedComponents", validateOnChange: true }, (arrayHelpers) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(style_1.ScrollableTableContainer, { sx: { overflowX: "initial" } },
                    react_1.default.createElement(Table_1.default, { stickyHeader: true, sx: { height: "fit-content" } },
                        react_1.default.createElement(DyanmicTableHead_1.default, { tableHeadCells: constants_1.tableHeadCells }),
                        react_1.default.createElement(TableBody_1.default, null,
                            react_1.default.createElement(TableRowContext_1.TableRowProvider, { fieldArrayName: "associatedComponents", arrayHelpers: arrayHelpers },
                                componentRowInputs["associatedComponents"]?.map((row, index) => {
                                    let errorMessage = "";
                                    if (errors?.associatedComponents &&
                                        (0, has_1.default)(errors?.associatedComponents, index)) {
                                        errorMessage = errors?.associatedComponents[index];
                                    }
                                    else {
                                        errorMessage = "";
                                    }
                                    return (react_1.default.createElement(DynamicTableRow_1.default, { key: `${row?.id}-${index}` },
                                        react_1.default.createElement(style_1.DragNDropHandler, null,
                                            react_1.default.createElement(fa_1.FaGripLines, null)),
                                        react_1.default.createElement(SimpleCell_1.default, { variant: "body", align: "left" },
                                            react_1.default.createElement(AutocompleteField_1.default, { name: `associatedComponents[${index}].name`, options: selectComponentOptions, autocompleteStyles: style_1.AutoCompleteStyle, value: componentRowInputs["associatedComponents"][index]?.name ||
                                                    "", id: "associatedComponents", placeholder: "Select Component", error: !!errorMessage, helperText: errorMessage, isOptionEqualToValue: (option, value) => {
                                                    return option?.label === value?.label;
                                                }, onChange: onChange(arrayHelpers, index), inputStyles: style_1.InputStyle })),
                                        react_1.default.createElement(SimpleCell_1.default, { variant: "body", align: "left" },
                                            react_1.default.createElement(react_1.default.Fragment, null, row?.unit)),
                                        react_1.default.createElement(DeletableCell_1.default, { align: "right", disabled: index ===
                                                arrayHelpers.form.values["associatedComponents"].length -
                                                    1, onDelete: onDeleteComponent(arrayHelpers, componentRowInputs["associatedComponents"][index], index) })));
                                }),
                                react_1.default.createElement(RemoveAssociationDialog_1.default, { arrayHelpers: arrayHelpers })))))));
        }),
        react_1.default.createElement(ProductPrompt_1.default, null),
        react_1.default.createElement(ProductsToast_1.default, null)));
}
exports.default = AssociationTable;
